define([
    'text!furniture-list-new2024/component/page-content.html',
    'common/utils',
    'WebCommon/component/image-link-slick',
    'common/api',
    'furniture-list-new2024/common/api',
    'lodash',
    'jquery',
    'common/mixin/route',
    'WebCommon/modal/modal'

], function(
    tpl,
    Utils,
    ImageLinkSlick,
    Api,
    Newapi,
    _,
    $,
    RouteMixin,Modal
){
    return {
        template: tpl,
        components: {
            ImageLinkSlick: ImageLinkSlick,
        },
        mixins: [RouteMixin],
        data: function(){
            return {
                slides: [],
                categories: [],
                productType: 1,
                furList: [],
                tableData: [],
                typeList: [
                    {name: '全部',tab: '',link: '/furniture?tab=all'},
                    {name: '椅',tab: '#chair',link: '/furniture?tab=all#chair'},
                    {name: '桌',tab: '#desk',link: '/furniture?tab=all#desk'},
                    {name: '床',tab: '#bed',link: '/furniture?tab=all#bed'},
                    {name: '几',tab: '#lowtable',link: '/furniture?tab=all#lowtable'},
                    {name: '柜',tab: '#cab',link: '/furniture?tab=all#cab'},
                    {name: '沙发',tab: '#sofa',link: '/furniture?tab=all#sofa'},
                    {name: '一枚板',tab: '#ymb',link: '/furniture?tab=all#ymb'},
                    {name: '其他',tab: '#other',link: '/furniture?tab=all#other'}
                ],
                newTypeList: [
                    {name: '新品',tab: 'recommend',link: '/furniture-l2?bom=recommend'},
                    {name: '大地线',link: '/furniture-l2?bom=base'},
                    {name: '山脊线',link: '/furniture-l2?bom=high'},
                    {name: 'FF线',link: '/furniture-l2?bom=ff'},
                    // {name: '回顾',link: '/furniture-l2?bom=ff'},
                ],
                furTab: '',
                isPC: true,
                isZh: true,
                proWidth: 0,
                innerWidth: 0,
                mouseIn: -1
            };
        },
        computed: {

        },
        watch: {
            categories: 'onRouteChange',
            '$i18n.locale': function () {
                // this.init();
                this.locale();
            }
        },
        methods: {
            changeType: function(type){
                var _this = this;
                var urlParams = new URLSearchParams(window.location.search);
                var newUrl = new URL(window.location);
                urlParams.set('tab', type);
                newUrl.search = urlParams.toString();
                history.pushState({}, '', newUrl);
                _this.furTab = type;
                _this.initCategories();
            },
            initCategories: function(){
                var _this = this;
                var pr = {
                    category: _this.furTab,
                    fnjiType: 1,
                    lang: ''
                };
                if(_this.$i18n.locale=='en'){
                    pr.lang = 'en';
                }
                return Newapi.getProListApi.ajax(pr)
                    .done(function(data){
                        // console.log(data);
                        _this.tableData = data;
                        _this.$set(_this.tableData,_this.tableData);
                    });
            },
            onClickSH:function() {
                var _this = this;

                $("body").on("click", ".m-link-slick .slick-slide", function (e) {

                    if(_this.slides[$(this).index()]['description'] != '上海预约')
                        return;
                  e.preventDefault();
                  e.stopPropagation();
                  Modal.showFnjiWeixinSrvModal();
              });
            },
            locale: function(){
                var _this = this;
                _this.proWidth = window.innerWidth*0.9/4;
                _this.innerWidth = window.innerWidth;
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                    _this.typeList = _this.$i18n.messages.en.typeList;
                    _this.newTypeList = _this.$i18n.messages.en.newTypeList;
                }else {
                    _this.isZh = true;
                    _this.typeList = _this.$i18n.messages.zh.typeList;
                    _this.newTypeList = _this.$i18n.messages.zh.newTypeList;
                }
                if($(window).width()<=750){
                    _this.isPC = false;
                }else {
                    _this.isPC = true;
                }
            },
            init: function(){
                var _this = this;
                var obj = _this.queryURLParams();
                console.log(obj);
                _this.furTab = obj.tab;
                var pr = {
                    fnjiType: 1,
                    lang: ''
                };
                if(_this.$i18n.locale=='en'){
                    pr.lang = 'en';
                }
                Newapi.getFurnitureApi.ajax(pr)
                    .done(function(data){
                        _this.furList = data;
                        // if(_this.furList.length){
                        //     _this.furTab = _this.furList[0].value;
                        // }
                        _this.initCategories();
                    });
            },
            queryURLParams: function() {
                var url = window.location.href;
                // 1.创建a标签
                var link = document.createElement('a');
                link.href = url;
                var searchUrl = link.search.substr(1); // 获取问号后面字符串
                var hashUrl = link.hash.substr(1); // 获取#后面的值
                var obj = {}; // 声明参数对象
                // 2.向对象中进行存储
                hashUrl ? obj['HASH'] = hashUrl : null; // #后面是否有值

                var list = searchUrl.split("&");
                for (var i = 0; i < list.length; i++) {
                    var arr = list[i].split("=");
                    obj[arr[0]] = arr[1];
                }
                return obj;
            },
            onRouteChange: function(){
                if (!this.categories.length) return;
                if (_.isEmpty(this.catGroup)){
                    this.replaceTabRoute(this.categories[1].type);
                    return;
                }
                this.$nextTick(function(){
                    this.scrollToPos();
                    this.hasInit = true;
                });
            },
            genFurnitureDetailLink: Utils.genFurnitureDetailLink,
            getSkuMainImage: function(sku){
                return Utils.genFnjiImageUrl(sku.mainImage) || Utils.genCdnImageUrl(sku.mainImg) || '';
            },
            getSkuBgColor: function(sku){
                return sku.bgColor ? sku.bgColor.value : '';
            },
            genFurnitureL2Link: Utils.genFurnitureL2Link
        },
        mounted: function(){
            this.init();
            // this.initCategories();
            this.locale();
        },
        filters: {
            descName: function(str){
                return (str||'').split(/\s*<br>\s*/)[0];
            }
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./furniture-list-new2024/component/page-content.js
// module id = 182
// module chunks = 4